import { NaicsCodeEntity } from '../../Models/Api/strongbox.financialportal';

export enum IndustriesActions {
    LoadStart = 'INDUSTRIES/LoadStart',
    LoadComplete = 'INDUSTRIES/LoadComplete',
    LoadError = 'INDUSTRIES/LoadError',
}

export interface ILoadIndustriesStart {
    readonly type: IndustriesActions.LoadStart;
}

export interface ILoadIndustriesComplete {
    readonly type: IndustriesActions.LoadComplete;
    readonly naicsCodes: NaicsCodeEntity[];
}

export interface ILoadIndustriesError {
    readonly type: IndustriesActions.LoadError;
    readonly error: string;
}

export type KnownAction =
    ILoadIndustriesStart |
    ILoadIndustriesComplete |
    ILoadIndustriesError;
